export default "__VITE_ASSET__b9$ZWzGQ__"